"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@mui/material/utils");
var Icon = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "currentColor", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fillRule: "evenodd", d: "M5.61 4.006h5.898v1.957c-.412.073-.83.164-1.256.27l-.48.118c-2.156.536-2.885.717-4.162.629V4.006Zm0 4.977v2.234c.577.039 1.021.018 1.514-.058.616-.095 1.31-.273 2.432-.562l.495-.127c.496-.127.98-.232 1.457-.312v-2.16c-.252.052-.51.11-.775.176l-.543.134h-.002v.001c-2.08.518-3.05.759-4.578.674Zm0 6.47v-2.232c.641.035 1.2.01 1.817-.085.723-.111 1.527-.318 2.622-.6l.499-.129c.33-.085.65-.157.96-.217v2.177c-.52.083-1.05.198-1.592.34l-.48.127h-.003c-1.096.29-1.77.467-2.37.561-.473.075-.9.096-1.453.059Zm0 2.004v1.79h5.898v-2.85c-.348.064-.708.146-1.084.245l-.487.128c-1.068.282-1.855.49-2.563.601-.6.094-1.144.12-1.764.086Zm7.898-1.237v5.026H3.61V2.006h9.898V5.75c.692-.019 1.371.025 2.047.142 1.707.295 3.312 1.043 4.98 2.291l.801.6-1.198 1.6-.8-.599c-1.475-1.103-2.793-1.691-4.123-1.921a8.334 8.334 0 0 0-1.707-.112v2.23c.57 0 1.133.047 1.693.148 1.66.297 3.218 1.05 4.832 2.3l.79.613-1.225 1.58-.79-.612c-1.422-1.102-2.687-1.685-3.96-1.913a7.557 7.557 0 0 0-1.34-.115v2.238c.489.01.973.057 1.455.145 1.63.299 3.156 1.055 4.733 2.307l.783.622-1.244 1.566-.783-.622c-1.386-1.1-2.616-1.68-3.85-1.906a7.073 7.073 0 0 0-1.094-.112Z", clipRule: "evenodd" }))); };
var SvgAirQuality = (0, utils_1.createSvgIcon)(React.createElement(Icon, null), 'SvgAirQuality');
exports.default = SvgAirQuality;
